import React from "react";
import "./RetailCart.css";
import { QuantitySelector } from "../products/ProductDetails";
import { ProductImage } from "../../../../images/Images";
import CartSummary from "./component/CartSummary";
import { useCart } from "../../../../context/CartContext";

const RetailCart: React.FC = () => {
  const { cart, updateQuantity, removeFromCart } = useCart();

  // Calculate subtotal, tax, and total
  const subTotal = cart.reduce(
    (sum, item) => sum + item.amount * item.quantity,
    0
  );
  const tax = subTotal * 0.029; // Example: 2.9% tax
  const total = subTotal + tax;

  return (
    <div className="retails-cart">
      <CartSummary subTotal={subTotal} tax={tax} total={total} />
      <h2 className="retails-cart-title">Cart</h2>

      {cart.length === 0 && <p>Your cart is empty.</p>}

      {cart.map((item) => (
        <div className="retails-cart-item" key={item.id}>
          <div className="retails-cart-item__main">
            <img src={item.image || ProductImage} alt="product image" />
            <div className="retails-cart-item-info">
              <div className="retails-cart-item-info-top">
                <h3 className="retails-cart-item-name">{item.name}</h3>
                <p className="retails-cart-item-stock">
                  {item.stock_count} Units Left in Stock
                </p>
              </div>

              <div>
                <div className="retails-cart-item-price">
                  <span>${item.amount?.toFixed(2)}</span>
                </div>

                <QuantitySelector
                  value={item.quantity}
                  min={1}
                  max={item.stock_count}
                  onChange={(qty) => updateQuantity(item.id, qty)}
                  onDelete={() => removeFromCart(item.id)}
                />
              </div>
            </div>
          </div>
          {item.storeName && (
            <p className="retails-cart-item-store">{item.storeName}</p>
          )}
        </div>
      ))}
    </div>
  );
};

export default RetailCart;
